<template>
  <div class="machine">
    <div class="machine-left">
      <left-tree
        :selected-keys="selectedKeys"
        :expanded-keys="expandKeys"
        @changeCustomer="(value) => changeCustomer(value)"
        @changeUnCustomer="(value) => changeUnCustomer(value)"
        @getTreeData="getTreeData"
        @setExpandKeys="setExpandKeys"
      ></left-tree>
    </div>
    <div id="black-main" class="machine-content main">
      <div class="machine-tool-top">
        <div class="machine-tool-top-flex">
          <div>
            <a-button v-acl="'page_ops_machine_create_machine'" type="primary" v-if="selectTab === '2'" @click="openEdit('0')">
              {{$t('page_ops_machine_create_machine')}}
            </a-button>
            <a-button
              v-acl="'page_ops_machine_delete_machine'"
              type="danger"
              :disabled="selectedIdList.length === 0"
              v-if="selectTab === '2'"
              @click="remove">
              {{$t('page_ops_machine_delete_machine')}}
            </a-button>
            <a-button
              v-acl="'page_ops_machine_move_machine'"
              :disabled="selectedIdList.length === 0"
              v-if="selectTab === '2'"
              @click="moveMachine">
              {{$t('page_ops_machine_move_machine')}}
            </a-button>
            <a-popconfirm
              :title="$t('page_ops_machine_remove_confirm')"
              :ok-text="$t('ok')"
              :cancel-text="$t('cancel')"
              :disabled="selectedIdList.length === 0"
              @confirm="moveCustomerMachine"
            >
              <a-button
                v-acl="'page_ops_machine_remove_machine'"
                type="danger"
                :disabled="selectedIdList.length === 0"
                v-if="selectTab === '1'"
              >
                {{$t('page_ops_machine_remove_machine')}}
              </a-button>
            </a-popconfirm>
          </div>
          <div class="machine-tool-top-right-flex">
            {{ $t('page_ops_machine_sort') }}：
            <a-select
              default-value="1"
              style="width: 120px"
              @change="handleSortRuleChange"
            >
              <a-select-option value="1">
                {{ $t('page_ops_machine_create_time') }}
              </a-select-option>
              <a-select-option value="2">
                {{ $t('page_ops_machine_model_machine_name') }}
              </a-select-option>
              <a-select-option value="3">
                {{ $t('page_ops_machine_model_machine_code') }}
              </a-select-option>
              <a-select-option value="4">
                {{ $t('page_ops_machine_model_machine_serialNo') }}
              </a-select-option>
            </a-select>
            <a-button style="width: 42px;margin-right: 8px" @click="changeSortRuleIcon"> 
              <a-icon style="color:#3a7fbc" :type="sortRuleIcon" />
            </a-button>
            <a-button style="margin-right: 8px" class="heightSearch" @click="handleAdvance"
              >{{ $t('page_my_document_advanced') }} <a-icon type="filter"
            /></a-button>
            <a-input-search
              v-model="filter.keywords"
              :placeholder="$t('common_please_input') + $t('page_ops_machine_keyword')"
              :enterButton="$t('search')"
              style="width: 300px"
              allowClear
              @search="search"
            />
          </div>
        </div>
        <div class="machine-list">
          <a-empty v-if="!machineList.length" />
          <div v-else class="machine-list-box">
            <div
              v-for="item in machineList"
              :key="item.id"
              :class="
                selectedMachine && item.id === selectedMachine.id
                  ? 'machine-list-item machine-list-item-active'
                  : 'machine-list-item'
              "
            >
              <a-checkbox
                :checked="selectedIdList.indexOf(item.id) !== -1"
                @change="machineCheckChange($event, item)"
              >
              </a-checkbox>
              <div class="machine-list-detail" @click="() => selectMachine(item)">
                <div class="machine-list-content">
                  <div>{{ item.name }}</div>
                  <div>({{ item.serialNo }})</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="machine-tool">
        <div>
          <a-button v-acl="'page_ops_machine_add_iot_feature'"
                    type="primary"
                    @click="openBindIot"
                    :disabled="(selectedMachineFeature&1)===1 && (selectedMachineFeature&2)===2"
          >{{$t('page_ops_machine_add_iot_feature')}}</a-button>
          <a-button v-acl="'page_ops_machine_edit_machine'" @click="edit" :disabled="!selectedIdList.length">{{$t('page_ops_machine_edit_machine')}}</a-button>
        </div>
        <div class="select-machine-info">
          <b class="blue-title">{{$t('page_ops_machine_info')}}</b>
          <a-empty v-if="!selectedMachine"></a-empty>
          <div v-if="selectedMachine">
            <a-row>
              <a-col span="4">
                <a-tag v-if="selectedMachine.isShared" color="green" class="tag">
                  {{$t('page_ops_machine_share')}}
                </a-tag>
                <img
                  class="machine-selected-img"
                  :src="getDeviceImg(selectedMachine.avatar, selectedMachine.name,imgListMap)"
                />
              </a-col>
              <a-col span="20">
                <a-descriptions title="">
                  <a-descriptions-item :label="$t('page_ops_machine_machine_code')">
                    {{ selectedMachine.code }}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('page_ops_machine_machine_name')">
                    {{ selectedMachine.name }}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('page_ops_machine_machine_serialNo')">
                    {{ selectedMachine.serialNo }}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('page_ops_customer_customer_name')">
                    <span style="cursor:pointer;color: #457cbe" @click="refreshTree(selectedMachine)">
                      {{ selectedMachine.customerName }}
                    </span>
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('page_ops_machine_model_machine_deliveryTime')">
                    {{ showDeliveryTime(selectedMachine.deliveryTime) }}
                  </a-descriptions-item>
                </a-descriptions>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="select-machine-iot" v-show="selectedMachine">
          <b class="blue-title">
            {{$t('page_ops_machine_iot_feature')}}
          </b>
          <machine-iot-detail ref="machineDetail" @changeIot="changeIot" @remove="removeDataFeature"></machine-iot-detail>
          <div v-show="hasConnectFeature" class="select-machine-iot-link">
            <div class="select-machine-iot-header">
              <b>
                {{$t('page_ops_machine_connect')}}
              </b>
              <a-popconfirm
                  v-if="hasConnectFeature"
                  placement="top" :ok-text="$t('ok')" :cancel-text="$t('cancel')" @confirm="removeConnectFeature">
                <template slot="title">
                  {{$t('delete_tips')}}
                </template>
                <a v-acl="'page_ops_machine_connect_feature_remove'" style="color:#ff0000;float: right">
                  {{$t('page_ops_machine_remove')}}
                </a>
              </a-popconfirm>
            </div>
            <div class="select-machine-iot-body">
              <machine-iot-connect-feature ref="iotConnectFeature"></machine-iot-connect-feature>
            </div>
          </div>
        </div>
      </div>
      <advance-search
        :visible="advanceVisible"
        :item="advanceKeys"
        @close="closeToggleSearch"
        @advanceSearch="startToggleSearch"
      ></advance-search>
    </div>
    <machine-edit ref="machineEdit" @save="editSave"> </machine-edit>
    <move-machine-modal
      :visible="moveMachineVisible"
      @cancel="cancelMove"
      @ok="(value) => moveMachineSave(value)"
    ></move-machine-modal>
    <machine-bind-iot ref="machineBindIot" @save="refreshDetail"></machine-bind-iot>
  </div>
</template>

<script>
import MoveMachineModal from './components/MoveMachine.vue'
import MachineEdit from './components/edit.vue'
import LeftTree from './components/LeftTree.vue'
import MachineBindIot from './components/bind-iot.vue'
import MachineIotConnectFeature from './components/iot-connect-feature.vue'
import AdvanceSearch from './components/advanceSearch.vue'
import MachineIotDetail from './components/iot-detail.vue'
import {
  DeleteMachineListDTO,
  MachineServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {
  GatewayExtranetServiceProxy
} from "@/service-proxies/app-v2/extranet.service-proxies";
import {GatewayServiceProxy} from "@/service-proxies/app-v2/iot-console.service-proxies";
import {UnbindMachineIotDTO} from "../../../service-proxies/app-v2/workStation.service-proxies";
import dayjs from 'dayjs';
import { getDeviceImg } from '../customer/utils/index'
import { DictBizServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const dictBizServiceProxy = new DictBizServiceProxy()

const machineSrvProxy = new MachineServiceProxy();
const gatewayExtranetSrvProxy = new GatewayExtranetServiceProxy();
const gatewaySrvProxy = new GatewayServiceProxy()
const csp = new CustomerServiceProxy();

const dataCollection=1;
const remoteConnection=2;
const noFeature  =0;

function getCollectionFeature(id){
  return machineSrvProxy.feature(id).then((res)=>{
    return res.hasDataCollection? dataCollection:noFeature;
  });
}

function getConnectFeature(id){
  return gatewayExtranetSrvProxy.getFeature(id).then((res)=>{
    return res.hasFeature?remoteConnection:noFeature;
  });
}

export default {
  components: {
    MachineBindIot,
    MachineIotConnectFeature,
    MachineEdit,
    MoveMachineModal,
    LeftTree,
    AdvanceSearch,
    MachineIotDetail
  },
  data() {
    return {
      dayjs,
      total: 0,
      pageIndex: 1,
      pageSize: -1,
      filter: {
        sortRuleType: 1,
        asc: false,
        keywords: ''
      },
      advanceKeys: {
        customerId: '',
        isAssigned: false,
        assemblyState: '',
        deviceTypeId: '',
        keywords: undefined
      },
      gatewayCode: undefined,
      gatewayId: undefined,
      gatewayStatue: false,
      machineList: [],
      selectedIdList: [],
      selectedMachine: undefined,
      selectedMachineFeature: 0,
      selectTab: '2',
      moveMachineVisible: false,
      advanceVisible: false,
      iotInfoId: undefined,
      sortRuleIcon:"sort-descending",
      areaNameList: [],
      selectedKeys: ['un-00'], // 设置tree高亮
      treeData: [],
      expandKeys: ['00-00'],
      imgListMap: {},
      getDeviceImg
    }
  },
  watch: {
    '$route.query': {
      handler(v){
        if(v.keyWord) {
          this.filter.keywords = v.keyWord;
        }
        if(v.customerName) {
          this.selectedKeys = ['00-00'];
          this.selectTab = '1'
        } else {
          this.selectedKeys = ['un-00'];
          this.selectTab = '2'
        }
        this.$nextTick(()=>{
          this.advanceKeys = {
            customerId: '',
            isAssigned: v.customerName ? true : false,
            assemblyState: '',
            deviceTypeId: '',
            iotState: undefined,
            createTimeStart: undefined,
            createTimeEnd: undefined
          }
          this.refresh()
        });
      },
      immediate: true,
      deep: true
    }
  },
  computed:{
    hasConnectFeature(){
      return (this.selectedMachineFeature & remoteConnection)===remoteConnection ;
    },
    hasDataFeature(){
      return (this.selectedMachineFeature & dataCollection)===dataCollection ;
    },
  },
  created() {
      dictBizServiceProxy.dictionary('device_image').then(res => {
        if (res.data && res.data.length > 0) {
          res.data.forEach(re => {
            this.imgListMap[re.dictValue] = re.dictKey
          })
        }
      })
  },
  methods: {
    setExpandKeys(arr) {
      this.expandKeys= arr;
    },
    // 跳转tree
    refreshTree(data) {
      //  查询到当前节点
      const arr = this.getCurrentNode(this.treeData, data.customerId);
      this.expandKeys = arr.map(v=>v.code);
      const params = { key: [data.customerId], data: arr[0] }
      this.changeCustomer(params);

    },
    getCurrentNode(list, key) {
      for (let i in list) {
        if (list[i].code === key) {
          return [list[i]];
        }else{
          let arr = list[i].children;
          if (arr && arr.length) {
            let node = this.getCurrentNode(arr, key);
            if (node !== undefined) {
              return node.concat(list[i]);
            }
          }
        }

      }
    },
    getTreeData(data){
      this.treeData = data;
    },
    changeIot(value){
      this.iotInfoId = value
    },
    removeDataFeature(value){
      this.refreshDetail();
    },
    handleAdvance() {
      this.advanceVisible = !this.advanceVisible
    },
    closeToggleSearch() {
      this.advanceVisible = false
    },
    startToggleSearch(values) {
      // this.advanceKeys.areaNameList = values.areaNameList
      this.advanceKeys.machineName = values.machineName
      this.advanceKeys.customerName = values.customerName
      this.advanceKeys.assemblyState = values.assemblyState
      this.advanceKeys.deviceTypeId = values.deviceTypeId
      this.advanceKeys.iotState = values.iotState

      if (values.createTimeRange != undefined && values.createTimeRange.length == 2) {
        this.advanceKeys.createTimeStart = values.createTimeRange[0]
        this.advanceKeys.createTimeEnd = values.createTimeRange[1]
      } else {
        this.advanceKeys.createTimeStart = undefined
        this.advanceKeys.createTimeEnd = undefined
      }
      this.filter.keywords = ''
      // this.advanceVisible = false
      this.refresh()
    },
    back() {
      this.$router.push('/dashboard')
    },
    changeCustomer({key, data}) {
      this.selectedKeys = key;
      this.selectTab = '1'
      this.areaNameList = data.flag? [data.parentCode] : (data.code ? (key[0] === "00-00" ? [] : [data.name]) :  [])

      this.advanceKeys = {
        customerId: data.flag ? data.code : '',
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      }
      this.refresh()
      this.selectedMachine = '';
    },
    changeUnCustomer(v) {
      this.selectedKeys = [v];
      this.selectTab = '2'
      this.areaNameList = []
      this.advanceKeys = {
        customerId: '',
        isAssigned: false,
        assemblyState: '',
        deviceTypeId: ''
      }
      this.refresh()
    },
    removeConnectFeature(){
      if (this.selectedMachine===undefined || this.selectedMachine.id===undefined){
        return;
      }
      const input = new  UnbindMachineIotDTO();
      input.featureValue=2;
      input.gatewayId = this.gatewayId;
      input.machineId= this.selectedMachine.id;
      machineSrvProxy.unbindIot(input).then(()=>{
          return gatewayExtranetSrvProxy.clear(this.selectedMachine.id)
      }).then(res=>{
        this.$message.success('移除IOT连接功能成功');
        this.refreshDetail();
      });
    },
    machineCheckChange(e, item) {
      if (e.target.checked) {
        this.selectedIdList.push(item.id)
      } else {
        const index = this.selectedIdList.findIndex((c) => c === item.id)
        if (index > -1) {
          this.selectedIdList.splice(index, 1)
        }
      }
    },
    async refreshDetail(){
      if(!this.selectedMachine){
        return ;
      }
      await this.selectMachine(this.selectedMachine);
    },
    async selectMachine(machine) {
      if (machine) {
         this.selectedMachine = machine;
      }else {
         this.selectedMachine = '';
      }  
      // this.selectedMachine = {};
      this.selectedMachineFeature=0
      this.selectedIdList = [machine.id]
     
      this.$refs.machineDetail.show(machine.id)
      this.$refs.iotConnectFeature.show(machine.id)


      const connect = await getConnectFeature(machine.id);
      const data = await getCollectionFeature(machine.id);
      this.selectedMachineFeature = this.selectedMachineFeature | connect;
      this.selectedMachineFeature = this.selectedMachineFeature | data;

      const connectFeature =  await gatewayExtranetSrvProxy.getFeature(machine.id);
      if (connectFeature.hasFeature){
        const gateway = await gatewaySrvProxy.getGatewayByCode(connectFeature.gatewayCode);
        this.gatewayCode=gateway.code;
        this.gatewayStatue = gateway.isOnline;
        this.gatewayId = gateway.id;
      }

    },
    search() {    
      this.advanceKeys = {
        customerId: '',
        isAssigned: this.selectTab != '2',
        assemblyState: '',
        deviceTypeId: ''
      } 
      this.refresh()
    },
    refresh() {
      this.$refs.machineDetail.iotPropertyItemList = []
      this.$refs.machineDetail.iotInfo = {
        id: undefined,
        code: undefined,
        status: false
      }
      this.selectedIdList = []
      this.machineList = []
      
      this.advanceKeys.areaNameList = this.areaNameList,
      this.advanceKeys.keywords = this.filter.keywords
      this.advanceKeys.asc = this.filter.asc
      this.advanceKeys.sortRuleType = this.filter.sortRuleType
      machineSrvProxy
        .getMachineList(this.pageIndex, this.advanceKeys, this.pageSize)
        .then((res) => {
          this.total = res.total
          this.machineList = res.records
          if (res.records && res.records.length > 0) {
            if(this.selectedMachine){
              const machine = res.records.find(item => item.id === this.selectedMachine.id)
              if(machine){
                this.selectedMachine = undefined
                setTimeout(() => {
                  this.selectMachine(machine)
                }, 50);
              } else {
                this.selectedMachine = undefined
                this.selectMachine(res.records[0])
              }
            } else {
              this.selectedMachine = undefined
              this.selectMachine(res.records[0])
            }
          } else {
            this.$refs.machineDetail.show('')
            this.$refs.iotConnectFeature.show('')
            this.selectedMachine = undefined
            this.gatewayCode = undefined
            this.gatewayId = undefined
            this.gatewayStatue = false
            this.selectedMachineFeature = 0
          }
        })
    },
    edit() {
      if (this.selectedMachine) {
        this.openEdit(this.selectedMachine.id)
      } else {
        this.$message.error(this.$t('page_ops_machine_no_select'))
      }
    },
    openBindIot() {
      if (!this.selectedMachine) {
        this.$message.error(this.$t('page_ops_machine_no_select'))
        return
      }
      this.$refs.machineBindIot.open(this.selectedMachine.id, this.selectedMachine.code)
    },
    openEdit(editId) {
      this.$refs.machineEdit.open(editId)
    },
    editSave() {
      this.refresh()
    },
    remove() {
      if (this.selectedIdList.length === 0) {
        this.$message.error(this.$t('page_ops_machine_no_select'))
        return
      }

      this.$confirm({
        title: this.$t('page_ops_machine_delete_machine'),
        content: this.$t('page_ops_machine_delete_confirm'),
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          const dto = new DeleteMachineListDTO()
          dto.idList = [...this.selectedIdList]
          machineSrvProxy.deleteMachineList(dto).then((res) => {
            if (res.success) {
              this.$message.success(this.$t('delete_success'))
              this.refresh()
            } else {
              const dataValue = Array.from(new Set(res.errorMachineList))
              this.$error({
                title: this.$t('delete_fail'),
                icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
                content: h('div', {}, [
                  h('p', this.$t('page_ops_machine_bound_iot')),
                  dataValue.map((res) => {
                    return h('p', res)
                  })
                ]),
                okText: this.$t('ok'),
                okType: 'danger'
              })
            }
          })
        }
      })
    },
    moveMachine() {
      this.moveMachineVisible = true
    },
    cancelMove() {
      this.moveMachineVisible = false
    },
    async moveCustomerMachine() {
      const workStationIds = []
      this.machineList.forEach((res) => {
        if (this.selectedIdList.indexOf(res.id) != -1) {
          const val = {
            customerId: res.customerId,
            workStationId: res.id
          }
          workStationIds.push(val)
        }
      })
      await csp.deleteWorkStationCustomer({ customerWorkStationList: workStationIds })
      this.$message.success(this.$t('page_ops_machine_unbind_success'))
      this.refresh()
    },
    async moveMachineSave(value) {
        const workStationIds = this.selectedIdList.join(',')
        await csp.saveWorkStationCustomer(value, workStationIds)
        this.$message.success(this.$t('page_ops_machine_bind_success'))
        this.moveMachineVisible = false
        this.refresh()
    },
    handleSortRuleChange(value){
      this.filter.sortRuleType = value
      this.search()
    },
    changeSortRuleIcon(){
      this.filter.asc = !this.filter.asc
      this.sortRuleIcon = this.filter.asc?"sort-ascending":"sort-descending"
      this.search()
    },
    showDeliveryTime(time) {
      return time? dayjs(time).format('YYYY-MM-DD') : ''
    }
  }
}
</script>

<style lang="less" scoped>
.machine {

  .iot-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 13px;
  }

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 0px;
  .text {
    padding: 24px;
    p {
      font-size: 20px;
    }
  }

  .machine-left {
    background: #ffffff;
    width: 310px;
    height: 100%;
    border: 1px solid #d7d7d7;
    /deep/ .ant-tabs-nav {
      width: 100%;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab {
      width: 50%;
      margin: 0;
      text-align: center;
      background-color: #f8f8f8;
      transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      border: 1px solid #d7d7d7;
    }
    /deep/.ant-tabs-nav .ant-tabs-tab-active {
      background-color: #ffffff;
      border: 0;
    }
    /deep/.ant-tabs-nav-wrap {
      margin: 0;
    }
    /deep/.ant-tabs-bar {
      margin: 0;
      border-bottom: 0;
    }
    /deep/ .ant-tabs {
      height: 100%;
    }
    /deep/ .ant-tabs-ink-bar {
      top: 0;
      height: 4px;
    }
  }
  .machine-content {
    background: #ffffff;
    margin-left: 10px;
    flex: 1;
    height: 100%;
    border: 1px solid #d7d7d7;
  }

  .machine-list {
    border: 1px solid #d7d7d7;
    height: 200px;
    overflow-y: scroll;
    padding: 8px;
    margin-top: 8px;
    .machine-list-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      .machine-list-item {
        width: 13%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: flex-start;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 4px;
        margin: 4px;
        background-color: #f8f8f8;
      }
      .machine-list-item-active {
        background-color: #fff1b8;
      }
      .machine-list-detail {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        .machine-list-img > img {
          width: 48px;
          height: auto;
        }
        .machine-list-content {
          padding: 8px;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          width: 100%;
        }
      }
    }
  }
  .machine-tool-top {
    padding: 8px;
    border-bottom: 1px solid #d7d7d7;
    button {
      margin-right: 8px;
    }
  }
  .machine-tool-top-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  }
  .machine-tool-top-right-flex {
    display: flex;
    align-items: center;
  }
  .machine-tool {
    padding: 8px;
    height: calc(100% - 265px);
    overflow: auto;

    button {
      margin-right: 8px;
    }
  }

  .blue-title {
    padding-left: 8px;
    border-left: 4px solid #457cbe;
    line-height: 22px;
    color: #457cbe;
    font-size: 14px;
  }

  .machine-selected-img {
    height: 70px;
  }
  .select-machine-info {
    padding-top: 8px;
  }
  .select-machine-iot-link {
    padding-top: 8px;
    .select-machine-iot-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8f8f8;
      border: 1px solid #d8d8d8;
      border-top: 4px solid #4a90e2;
      padding: 4px 8px;
      font-weight: bold;
    }
    .select-machine-iot-body{
      border: 1px solid #d8d8d8;
      padding: 4px;
      border-top: 0 solid transparent;
    }
  }
  /deep/ .ant-tabs .ant-tabs-top-content.ant-tabs-content-animated,
  /deep/ .ant-tabs .ant-tabs-bottom-content.ant-tabs-content-animated {
    height: calc(100% - 46px);
    overflow: hidden;
  }
  .tag {
    position: absolute;
    left: 72px;
  }
}
</style>
